import React from 'react';
import s from './BaseComp.scss';

/**
 * @component
 * Image Item in card
 * @param props {ItemProps} - props
 */
export const ItemImageLoading = () => {
    // @render
    return (
        <div className={s.imageCompLoadingBox}>
            <div className={s.coverBox} />
            <div className={s.label} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/ImageFeedItem.loading.tsx